import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFuraffinityComponent } from './simple-icons-furaffinity.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFuraffinityComponent ],
    exports:      [ SimpleIconsFuraffinityComponent ],
    bootstrap:    []
})
export class SimpleIconsFuraffinityModule {}
